import { render, staticRenderFns } from "./ProductDetailsRelatedProducts.vue?vue&type=template&id=097d4c8b"
import script from "./ProductDetailsRelatedProducts.vue?vue&type=script&lang=js"
export * from "./ProductDetailsRelatedProducts.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsRelatedProducts.vue?vue&type=style&index=0&id=097d4c8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports